import { IRootState } from '../../../store'

export const getPcrIdSelector = (state: IRootState): string | undefined => state.home.pcrId
